import { RefObject, useEffect, useRef } from "react";

export function useClickOutside(
  ref: RefObject<HTMLElement>,
  onOutside: () => void,
  enabled: boolean = true,
) {
  // Ref, чтобы новый колбэк на каждый рендер не переподписывал слушатель.
  const onOutsideRef = useRef(onOutside);
  useEffect(() => {
    onOutsideRef.current = onOutside;
  }, [onOutside]);

  useEffect(() => {
    if (!enabled) return;

    const handleMouseDown = (event: MouseEvent) => {
      const { target } = event;
      if (target instanceof Node && !ref.current?.contains(target)) {
        onOutsideRef.current();
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, [ref, enabled]);
}
